<template>
  <div id="header">
    <p class="title max-width">
      税务行业解决方案提供者！
      <span class="title-text1">
      全国热线：400-8778-367
      </span>

      <span class="weixin-pointer">
        <img src="../assets/weixin.png" class="weixin"/>
        <img src="../assets/wb2.png" class="weixin-QR"/>
      </span>
      <a href="http://e.weibo.com/cooperationsoft/profile" target="_blank">
        <img src="../assets/weibo.png">
      </a>
      <img src="../assets/email.png">
    <span class="loginUser" v-show="loginUser.name!=''">
      <span>{{ loginUser.name }}</span>
      <a href="javascript:;" @click="tuichu">退出</a>
    </span>
    </p>
    <div class="top">
      <div class="imgs max-width">
        <a href="/" target="_blank"><img
          src="../assets/logo_v2.gif"></a>
        <img src="../assets/logo_line.png">
        <img src="../assets/line_font.png">
        <!--<p class="loginUser" v-show="loginUser.name!=''">
          <span>{{ loginUser.name }}</span>
          <a href="javascript:;" @click="tuichu">退出</a>
        </p>-->
        <ul :class="['topNav', this.$route.name==='Authentication' || this.$route.name==='inputShow' || this.$route.name==='Applylist' ? '':'none']">
          <li v-bind:class="{'current':this.$route.name==='Authentication'}" @click="changeRouters('Authentication')">认证申请处理</li>
          <li v-bind:class="{'current':this.$route.name==='inputShow'}"  @click="changeRouters('inputShow')">填表说明管理</li>
          <li v-bind:class="{'current':this.$route.name==='Applylist'}" @click="changeRouters('Applylist')">委托录入记录</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Header',
    data () {
      return {
        loginUser:this.$store.getters.getLoginUser1
      }
    },
    created:function(){
      // this.loginUser = this.$store.loginUser
    },
    activated: function () {
      // this.loginUser = this.$store.loginUser
    },
    mounted:function(){
      var that = this;
      // this.loginUser = this.$store.loginUser
      // console.log(this.$store)
      // console.log(this,this.$store.loginUser);
      console.log('router',this.$route.name)
      setTimeout(function(){
        // that.loginUser = that.$store.loginUser
      },500)
    },
    methods:{
      tuichu:function(){
      var that =this;
        this.$axios({
          method: 'post',
          url: '/User/LoginOut',
          data: {}
        })
          .then(res => {
            window.location.href = "/Regest/Index"
          })
          .catch(err => {
            // that.$message.error('网络连接失败');

          })
      },
      changeRouters:function (link){
        this.$router.push({
          'name':link,
          'query':{
            name:this.loginUser.name
          }
        })
      }
    }
  }
</script>

<style scoped>
  div, p {
    box-sizing: border-box;
    overflow: visible;
  }

  .max-width {
    max-width: 1200px;
  }

  #header {
    width: 100%;
    height: auto;
    transition: all .3s;
  }

  .title {
    height: 34px;
    line-height: 34px;
    margin: 0 auto;
    font-size: 12px;
    color: #9D9D9D;
    letter-spacing: 0;
  }

  .title:before {
    display: none;
  }

  .title img {
    width: 18px;
    height: 18px;
    cursor: pointer;
    margin-left: 10px;
    vertical-align: text-bottom;
  }

  .title .title-text1 {
    margin-left: 74px;
  }

  .title .weixin {
    margin-left: 21px;
  }

  .weixin-pointer {
    position: relative;
  }

  .weixin-pointer:hover .weixin-QR {
    opacity: 1;
  }

  .weixin-pointer .weixin-QR, .weixin-pointer .weixin-QR:hover {
    position: absolute;
    width: 120px !important;
    height: 120px !important;
    top: 16px;
    left: 0;
    opacity: 0;
    cursor: unset;
    z-index: 1;
  }

  .top {
    /*height: 80px;*/
    height: 82px;
    width: 100%;
    background-color: white;
    position: relative;
  }

  .top .imgs {
    /*padding-top: 16px;*/
    vertical-align: middle;
    margin: 0 auto;
  }

  #header .loginUser {
    padding: 0px;
    margin: 0px;
    display: block;
    width: auto;
    /*height: 40px;*/
    /*line-height: 50px;*/
    float: right;
    font-size: 12px;
    color: #6E7E8D;
  }
  #header .loginUser span{ margin-right: 10px;}
  #header .loginUser a {
    color: #6E7E8D;
  }
  .imgs img {
    vertical-align: middle;
  }
  #header .topNav{ float: right; display: block; height:40px; line-height: 40px; margin-top: 16px}
  #header .topNav li{font-size: 14px;
    color: #535353; display: inline-block; margin: 0px 25px; cursor: pointer;height:50px;}
  #header .topNav li:hover,#header .topNav li.current{color: #1B7EF1; background: url(../assets/navCuricon.png) no-repeat center bottom;}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue